import { render, staticRenderFns } from "./ProductAssemblytype.vue?vue&type=template&id=18892de8"
import script from "./ProductAssemblytype.vue?vue&type=script&lang=js"
export * from "./ProductAssemblytype.vue?vue&type=script&lang=js"
import style0 from "./ProductAssemblytype.vue?vue&type=style&index=0&id=18892de8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports